import { gql } from "@apollo/client";

export const GET_VISIBLE_LOCATIONS = gql`
    query GetVisibleLocations {
        visibleLocations {
            locationId
            name
        }
    }
`;

export const GET_VISIBLE_CLIENTS = gql`
    query GetVisibleClients($locationId: Int!) {
        visibleLocations(locationIds: [$locationId]) {
            advisers {
                clients {
                    clientId
                    forename
                    surname
                }
            }
        }
    }
`;
